module.exports = __webpack_public_path__ + "static/media/283b971e-061c-4466-91c8-5072eef0e125.81de4dc9.jpg";